import React from 'react';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '../hooks/useMediaQuery';
import { COPY } from '../data';
import { FooterNavLinks } from './FooterNavLinks';
import LogoWithBeta from './LogoWithBeta';

export default function SiteFooter({ linkColor = 'var(--muted)' }) {
  const m = useMediaQuery('(max-width: 900px)');
  const CONTACT_EMAIL = 'vanessa@orivonai.com';

  return (
    <footer
      style={{
        padding: m ? '28px 18px' : '36px 48px',
        borderTop: '2.5px solid var(--pink-m)',
        background: 'var(--white)',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 14,
        flexDirection: m ? 'column' : 'row',
        textAlign: m ? 'center' : 'left',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: m ? 'center' : 'flex-start' }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
          <LogoWithBeta compact={m} />
        </Link>
        <span style={{ fontSize: 11, color: linkColor }}>© 2026 OrivonAI · {COPY.footerTagline}</span>
        <span style={{ fontSize: 11, color: linkColor }}>
          Contact: <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: linkColor, fontWeight: 700, textDecoration: 'none' }}>{CONTACT_EMAIL}</a>
        </span>
      </div>

      <FooterNavLinks linkColor={linkColor} />
    </footer>
  );
}

